<template>
  <div class="app-container">
    <div class="filter-head">
      <div>
        <el-button type="primary" icon="el-icon-plus" @click="handleAddTable"
          >新增</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-upload2"
          :loading="tableLoading"
          @click="exportExcel"
          >导出Excel</el-button
        >
      </div>
      <el-row type="flex" align="middle">
        <div style="margin-right: 8px;white-space: nowrap;">招募时间</div>
        <el-date-picker
          class="filter-item"
          style="margin-right: 8px;"
          v-model="listQuery.date"
          @change="changedata"
          type="daterange"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-input
          style="max-width: 260px; margin-right: 8px;"
          v-model="listQuery.title"
          placeholder="活动标题"
          clearable
        ></el-input>
        <el-select
          style="margin-right: 8px;"
          v-model="listQuery.activity_state"
          placeholder="活动状态"
          clearable
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 8px;"
          v-model="listQuery.state"
          placeholder="状态"
          clearable
        >
          <el-option label="正常" value="1"></el-option>
          <el-option label="下架" value="0"></el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          :loading="tableLoading"
          @click="handleSearch"
          >搜索</el-button
        >
      </el-row>
    </div>
    <div class="table">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        element-loading-text="Loading"
        border
        fit
        height="70vh"
        highlight-current-row
      >
        <el-table-column type="index" label="序号" width="95" align="center" />
        <el-table-column label="封面" width="122" align="center">
          <template slot-scope="scope">
            <!-- <el-image style="width: 100px; height: 100px" :src="scope.row.cover_img" fit="cover" /> -->
            <img
              style="width:100px; height: 100px;object-fit: cover;"
              :src="scope.row.cover_img"
              alt="活动封面"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="activity_state"
          label="活动状态"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.activity_state === 1">准备中</el-tag>
            <el-tag v-else-if="scope.row.activity_state === 2" type="warning"
              >招募中</el-tag
            >
            <el-tag v-else-if="scope.row.activity_state === 3" type="success"
              >进行中</el-tag
            >
            <el-tag v-else-if="scope.row.activity_state === 4" type="danger"
              >已结束</el-tag
            >
            <el-tag v-else-if="scope.row.activity_state === 5" type="info"
              >已取消</el-tag
            >
            <el-tag v-else type="success">其它</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="recruit_at"
          label="招募时间"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="start_at"
          label="进行时间"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="end_at"
          label="结束时间"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="integarl_num"
          label="获得积分"
          width="110"
          align="center"
        />
        <el-table-column
          prop="passers_num"
          label="通过人数"
          width="95"
          align="center"
        />
        <el-table-column
          prop="activity_total_num"
          label="活动人数"
          width="95"
          align="center"
        />
        <el-table-column prop="sort" label="权重" width="95" align="center" />
        <el-table-column prop="state" label="状态" width="95" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state" type="success">正常</el-tag>
            <el-tag v-else type="danger">已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="400px"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditTable(scope.row)"
              >修改</el-button
            >

            <el-button
              v-if="scope.row.state === 0"
              type="primary"
              size="mini"
              @click="switchState('上架', scope.row.id)"
              >上架</el-button
            >
            <el-button
              v-else
              type="warning"
              size="mini"
              @click="switchState('下架', scope.row.id)"
              >下架</el-button
            >

            <el-button
              v-if="scope.row.activity_state === 5"
              size="mini"
              type="primary"
              @click="handleActivityStatus(scope.row.id, '恢复')"
              >恢复活动</el-button
            >
            <el-button
              v-else-if="scope.row.activity_state !== 5"
              size="mini"
              type="warning"
              @click="handleActivityStatus(scope.row.id, '取消')"
              >取消活动</el-button
            >

            <el-popconfirm
              style="margin:0 10px;"
              title="是否删除活动？"
              @confirm="handleDelAction(scope.row.id)"
              @onConfirm="handleDelAction(scope.row.id)"
            >
              <el-button slot="reference" size="mini" type="danger"
                >删除</el-button
              >
            </el-popconfirm>

            <el-button
              v-if="scope.row.state !== 0"
              size="mini"
              type="primary"
              @click="viewRegistration(scope.row.id, scope.row.title)"
              >查看报名</el-button
            >

            <el-button
              type="success"
              size="mini"
              style="margin-top: 10px;"
              @click="exportApplyExcel(scope.row)"
              >导出报名Excel</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <TableActiveModal
      :show.sync="activeVisible"
      :type="activeModalType"
      :edit-data="activeEditData"
      @onUpdate="onTableActionModalSubmit"
    />
  </div>
</template>

<script>
import TableActiveModal from './components/TableActiveModal'
import { questionnaire } from '@/api/order'
import {
  list,
  changeState,
  delEvent,
  cancel,
  exportActivityExcel,
} from '@/api/activity'
import * as XLSX from 'xlsx'
import { review } from '@/api/review'
import { platformList } from '@/utils/common'

export default {
  data: () => ({
    selectVal: null,
    selectOptions: [
      {
        value: 1,
        label: '准备中',
      },
      {
        value: 2,
        label: '招募中',
      },
      {
        value: 3,
        label: '进行中',
      },
      {
        value: 4,
        label: '已结束',
      },
      {
        value: 5,
        label: '已取消',
      },
    ],
    tableData: [],
    tableLoading: false,
    total: null,
    listQuery: {
      page: 1,
      limit: 10,
      title: '',
      activity_state: '',
      state: '',
    },
    activeVisible: false,
    activeModalType: 'add',
    activeEditData: null,
    questionnaireTemplate: null,
  }),
  components: {
    TableActiveModal,
  },
  methods: {
    async getTemplate(id) {
      const { data } = await questionnaire.questionnaireTemplate(id)
      this.questionnaireTemplate = data.template
      console.log(data)
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    async getList() {
      this.tableLoading = true

      this.tableData = []
      const { data } = await list(this.listQuery)
      this.total = data.total
      this.tableData = data.data

      this.tableLoading = false
    },
    handleEditTable(r) {
      if (r.activity_state !== 5) {
        return this.$message({
          message: '取消活动才能修改!',
          type: 'warning',
        })
      }
      this.setActiveModalType('edit')
      this.activeEditData = r
      this.activeVisible = true
    },
    onTableActionModalSubmit() {
      this.getList()
    },
    // 分页操作
    handleSizeChange(limit) {
      this.listQuery.limit = limit
      this.getList()
    },
    handleCurrentChange(page) {
      this.listQuery.page = page
      this.getList()
    },
    // 更改模式
    setActiveModalType(type) {
      this.activeModalType = type
    },
    handleAddTable() {
      this.setActiveModalType('add')
      this.activeVisible = true
    },
    switchState(text, id) {
      this.$confirm('此操作将' + text + '该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        changeState(id)
          .then(() => {
            this.$message({
              message: '操作成功!',
              type: 'success',
            })
            this.getList()
          })
          .catch(() => {
            this.$message.error('操作失败!')
          })
      })
    },
    async handleActivityStatus(id, text) {
      this.$confirm('此操作将' + text + '该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await cancel(id)
          this.$message({
            message: `已${text}活动!`,
            type: 'success',
          })
          this.getList()
        } catch {
          this.$message.error('操作失败!')
        }
      })
    },
    handleDelAction(id) {
      delEvent(id).then(() => {
        this.$message({
          message: '已删除该活动!',
          type: 'success',
        })
        this.getList()
      })
    },
    viewRegistration(id, title) {
      this.$router.push({
        name: 'RegistryList',
        params: { id },
        query: { title },
      })
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    // 导出报名Excel
    async exportApplyExcel(scope) {
      console.log('exportExcel', scope)
      // +++修改excel-活动列表-导出报名Excel-附件 7---ok
      const { total } = this
      if (!total) return
      if (scope.questionnaire_id) {
        await this.getTemplate(scope.questionnaire_id)
      }
      try {
        const {
          data: { data: reqData },
        } = await exportActivityExcel({
          id: scope.id,
          page: 1,
          limit: 99999999999,
        })
        console.log(reqData)
        var wb = XLSX.utils.book_new()

        var excelData = [
          [
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            ...reqData[0].activity_condition.map((item, index) =>
              index === 0 ? '报名信息' : ''
            ),
          ],
          [
            '报名序号',
            '用户名',
            '性別',
            '年龄',
            '手机号',
            '居住地-国家',
            '居住地-省份',
            '微信ID',
            '邮箱',
            '擅长领域',
            '活动名称',
            '报名时间',
            '申请次数',
            '活动状态',
            '招募时间',
            '进行时间',
            '结束时间',
            '获得积分',
            '权重',
            '状态',
            ...reqData[0].activity_condition.map((item) => item.name),
            ...(this.questionnaireTemplate
              ? this.questionnaireTemplate.map((item) => item.name)
              : []),
          ],
          ...reqData.map((item, index) => [
            index + 1,
            item.user_info.name,
            item.user_info.gender === 1
              ? '男性'
              : item.user_info.gender === 2
              ? '女性'
              : '未设置',
            item.user_info.age_group === 1
              ? '20岁以下'
              : item.user_info.age_group === 2
              ? '21~30岁'
              : item.user_info.age_group === 3
              ? '31~40岁'
              : item.user_info.age_group === 4
              ? '41~50岁'
              : item.user_info.age_group === 5
              ? '51岁以上'
              : '未设置',
            item.user_info.account,
            item.user_info.country,
            item.user_info.provinces,
            item.user_info.wx_id,
            item.user_info.email,
            item.user_info.evaluation_type_field.length > 0
              ? item.user_info.evaluation_type_field
                  .map((item) => item.name)
                  .join(',')
              : '',
            item.activity_info.title,
            item.created_at,
            item.application_number, // 申请次数
            item.activity_info.activity_state === 1
              ? '准备中'
              : item.activity_info.activity_state === 2
              ? '招募中'
              : item.activity_info.activity_state === 3
              ? '进行中'
              : item.activity_info.activity_state === 4
              ? '已结束'
              : item.activity_info.activity_state === 5
              ? '已取消'
              : '无字段',
            item.activity_info.recruit_at,
            item.activity_info.start_at,
            item.activity_info.end_at,
            item.activity_info.integarl_num,
            item.activity_info.sort,
            item.activity_info.state ? '正常' : '已下架',
            ...item.activity_condition.map(
              (activityItem) => activityItem.content
            ),
            ...(item.questionnaire_log
              ? this.questionnaireTemplate.map((questionItem, qIndex) => {
                  const answer = item.questionnaire_log[questionItem.id]
                  if (questionItem.type === 1 || questionItem.type === 3) {
                    if (
                      questionItem.option.length > 0 &&
                      questionItem.option[0] &&
                      typeof answer === 'number'
                    ) {
                      return questionItem.option[answer]
                    } else {
                      return answer || ''
                    }
                  } else if (questionItem.type === 2) {
                    return answer ? answer.join(',') : ''
                  } else if (questionItem.type === 4) {
                    return answer
                      ? `附件（${answer.map((item) => item.path)}）`
                      : ''
                  } else {
                    return answer || ''
                  }
                })
              : []), // 问卷答案
          ]),
        ]

        var ws = XLSX.utils.aoa_to_sheet(excelData)

        // 定义合并的范围
        const mergeCells = [{ s: { r: 0, c: 20 }, e: { r: 0, c: 22 } }] //索引从0开始;

        // 设置合并的单元格
        ws['!merges'] = mergeCells

        XLSX.utils.book_append_sheet(wb, ws, '报名列表')
        XLSX.writeFile(wb, `${scope.title}报名列表.xlsx`)

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...',
        })
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!',
        })
      }
    },
    // 导出Excel
    async exportExcel() {
      console.log('exportExcel')

      const { total } = this
      if (!total) return

      try {
        const {
          data: { data: reqData },
        } = await list({ ...this.listQuery, page: 1, limit: total })

        var wb = XLSX.utils.book_new()

        var excelData = [
          [
            '序号',
            '标题',
            '活动状态',
            '招募时间',
            '进行时间',
            '结束时间',
            '获得积分',
            '通过人数',
            '活动人数',
            '权重',
            '状态',
          ],
          ...reqData.map((item, index) => [
            index + 1,
            item.title,
            item.activity_state === 1
              ? '准备中'
              : item.activity_state === 2
              ? '招募中'
              : item.activity_state === 3
              ? '进行中'
              : item.activity_state === 4
              ? '已结束'
              : item.activity_state === 5
              ? '已取消'
              : '无字段',
            item.recruit_at,
            item.start_at,
            item.end_at,
            item.integarl_num,
            item.passers_num,
            item.activity_total_num,
            item.sort,
            item.state ? '正常' : '已下架',
          ]),
        ]
        var ws = XLSX.utils.aoa_to_sheet(excelData)
        XLSX.utils.book_append_sheet(wb, ws, '活动列表')
        XLSX.writeFile(wb, '活动列表.xlsx')

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...',
        })
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!',
        })
      }
    },
  },
  beforeMount() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
.filter-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table {
  margin-top: 10px;
}
</style>
